import { render, staticRenderFns } from "./AddRules.vue?vue&type=template&id=b84ad518&scoped=true&"
import script from "./AddRules.vue?vue&type=script&lang=js&"
export * from "./AddRules.vue?vue&type=script&lang=js&"
import style0 from "./AddRules.vue?vue&type=style&index=0&id=b84ad518&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84ad518",
  null
  
)

export default component.exports